import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  Stack,
} from "@mui/material";

import {
  BaseUrl,
  apiUrl_dialerp,
  apiTest_Url,
  Appname,
  subID,
  Authorization_Token,
  staticToken,
  LoggedInUserID,
  LoggedInUserName,
  AUTH_KEY,
  setLogindata,
} from "../Services/Urls";

import { callApi, makeApiRequest } from "../Services/ApiService";
import { decryptOtp } from "../Services/Helper";
import { TailSpin } from "react-loader-spinner";
import { getRecords, PostRecords } from "../Services/ApiCall";

import { GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";

const LoginDialog = ({ open, onClose, onSuccess, onUserDetails }) => {
  const [step, setStep] = useState("choice");
  const [loginType, setLoginType] = useState(null);
  const [otp, setOtp] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Name, setName] = useState("");

  const [Loading, setLoading] = useState(false);

  const handleClose = () => {
    setStep("choice");
    setLoginType(null);
    onClose();
  };

  const handleVerify = () => {
    if (otp.length === 4) {
      setLoading(true);
      let url = `${BaseUrl}/api/DynamicApp/mobileLoginVerifyOTPMongoV5`;
      let body = {
        baseTokenKey: AUTH_KEY,
        appVersion: "85",
        deviceOS: "android : 15 : VANILLA_ICE_CREAM : sdk=35",
        mobile: Mobile,
        tabErpID: "753",
        corporateCode: 10027,
        otp: otp,
        appVersionName: "85",
        deviceCountry: "India",
        deviceID: "",
        deviceName: "",
        imeiNumber: "not found",
        countryCode: "91",
        collectionNumber: "2",
        countryName: "India",
      };

      makeApiRequest(
        url,
        body,
        AUTH_KEY,
        (response) => {
          if (response.hasErrors === false && response != null) {
            // onSuccess(response?.response);
            // handleClose();
            // setLoading(false);
            getUserDetails(response?.response?.partySr, response?.response);
          } else {
            toast.error(`${response?.errors || "Wrong OTP Entered"}`);
            setLoading(false);
          }
        },
        (error) => {
          setLoading(false);
        }
      );
    }
  };

  const checkMobile = () => {
    if (Mobile.length === 10) {
      setLoading(true);

      let url = `${BaseUrl}/api/DynamicApp/checkMobileUserMongoDynamicV5?AppVersion=1.85&appName=RewardTrail&erpIDprm=0&parentIDprm=${10027}&HideColumns=1&cByPlatform=`;
      let body = {
        baseTokenKey: AUTH_KEY,
        EmailID: "",
        appVersion: "85",
        deviceOS: "android : 15 : VANILLA_ICE_CREAM : sdk=35",
        mobile: Mobile,
        corporateCode: 10027,
        appVersionName: "85",
        deviceCountry: "India",
        deviceID: "",
        deviceName: "",
        imeiNumber: "not found",
        countryCode: "91",
        collectionNumber: "2",
        countryName: "India",
      };

      makeApiRequest(
        url,
        body,
        AUTH_KEY,
        (response) => {
          //  console.log("check mobile response", response);
          if (response.hasErrors == false) {
            let url2 = `${BaseUrl}/api/DynamicApp/mobileSendOtpMongoV5?AppVersion=1.85&appName=${"LandPanda"}&erpIDprm=0&parentIDprm=${10027}&HideColumns=1&cByPlatform=`;
            let body2 = {
              baseTokenKey: AUTH_KEY,
              resend: "0",
              collectionNumber: "2",
              mobile: Mobile,
              corporateCode: 10027,
            };

            makeApiRequest(
              url2,
              body2,
              AUTH_KEY,
              (response2) => {
                if (response2.hasErrors === false) {
                  let decryptedCode = decryptOtp(response2.response);

                  //  console.log("decrypted otp", decryptedCode);

                  let url3 = `${apiUrl_dialerp}/api/DynamicSMS/SendSMS?AppVersion=1.85&appName=${"LandPanda"}&erpIDprm=0&parentIDprm=${10027}&HideColumns=1&cByPlatform=`;
                  let body3 = {
                    Message: `Otp for LandPanda App is ${decryptedCode}\nDIALERP Team`,
                    SubscriberID: 10001,
                    DltEntityID: "1201159187215982418",
                    TemplateDltID: "1007822973245487897",
                    SenderID: "DALERP",
                    CountryCode: "91",
                    userID: "2",
                    Mobile: Mobile,
                  };

                  makeApiRequest(
                    url3,
                    body3,
                    "",
                    (response3) => {
                      //if() console.log("SMS API response", response3);

                      if (response3.hasErrors === false) {
                        setLoading(false);
                        setStep("otp");
                      } else {
                        setLoading(false);
                      }
                    },
                    (error3) => {
                      setLoading(false);
                    }
                  );
                } else {
                  setLoading(false);
                }
              },
              (error2) => {
                setLoading(false);
              }
            );
          } else {
            setLoading(false);
            setStep("SignUp");
          }
        },
        (error) => {
          setLoading(false);
        }
      );
    }
  };

  const signup = () => {
    setLoading(true);

    let body = [
      {
        User: Name,
        ProfileID: 3,
        Profile: "Customer",
        Mobile: Mobile,
      },
    ];

    PostRecords(409, 2, body, (response) => {
      //console.log("signup response", response);

      if (response.hasErrors === false) {
        checkMobile();
      } else {
        setLoading(false);
      }
    });
  };

  const getUserDetails = (userID, data) => {
    getRecords(409, 1, `{UserID: { $in: [${userID}] }}`, 1, "", (response) => {
      // console.log("user details response", response);
      if (response.hasErrors === false) {
        if (response?.response?.records?.length > 0) {
          onSuccess(data);
          onUserDetails(response?.response?.records[0] ?? {});
          handleClose();
          setLoading(false);
        } else {
          setLoading(false);
        }
      } else {
        console.log("Error fetching user details");
        setLoading(false);
      }
    });
  };

  const handleSuccess = (credentialResponse) => {
    const decoded = jwtDecode(credentialResponse.credential);
   // console.log("User info:", decoded);
    // send credentialResponse.credential (ID token) to your server if needed
    googleLogin(decoded?.email, decoded?.name,decoded?.picture);
  };

  const handleError = () => {
    console.error("Login Failed");
  };

  const googleLogin = (email, name,picture) => {
    setLoading(true);

    let url = `${BaseUrl}/api/DynamicApp/checkMobileUserMongoDynamicV5?AppVersion=1.85&appName=RewardTrail&erpIDprm=0&parentIDprm=${10027}&HideColumns=1&cByPlatform=`;
    let body = {
      baseTokenKey: AUTH_KEY,
      EmailID: email,
      appVersion: "85",
      deviceOS: "android : 15 : VANILLA_ICE_CREAM : sdk=35",
      mobile: "0",
      corporateCode: 10027,
      appVersionName: "85",
      deviceCountry: "India",
      deviceID: "",
      deviceName: "",
      imeiNumber: "not found",
      countryCode: "91",
      collectionNumber: "2",
      countryName: "India",
    };

    makeApiRequest(
      url,
      body,
      AUTH_KEY,
      (response) => {
        //  console.log("check mobile response", response);
        if (response.hasErrors == false && response?.response != null) {
          getUserDetails(response?.response?.partySr, response?.response);
        } else {
          //  setLoading(true);

          let body_s = [
            {
              User: name,
              ProfileID: 3,
              Profile: "Customer",
              Email: email,
              ProfilePic: picture
            },
          ];

          PostRecords(409, 2, body_s, (response) => {
            //console.log("signup response", response);

            if (response.hasErrors === false) {
              makeApiRequest(
                url,
                body,
                AUTH_KEY,
                (response) => {
                  //  console.log("check mobile response", response);
                  if (
                    response.hasErrors == false &&
                    response?.response != null
                  ) {
                    getUserDetails(
                      response?.response?.partySr,
                      response?.response
                    );
                  } else {
                  

                    setLoading(false);
                  }
                },
                (error) => {
                  setLoading(false);
                }
              );

              //  checkMobile();
            } else {
              setLoading(false);
            }
          });
        }
      },
      (error) => {
        setLoading(false);
      }
    );
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      className="dialogg"
    >
      <DialogTitle textAlign="center">
        <a className="navbar-brand" href="index.html">
          <img
            className="logo-light"
            src="assets/img/logo.svg"
            alt="logo"
            style={{ margin: "0 auto" }}
          />
        </a>

        {/* {step === "choice" && "Login"} */}
        {step === "mobile" && "Login with Mobile"}
        {step === "email" && "Login with Email"}
        {step === "otp" && "Enter OTP"}
      </DialogTitle>
      <Button
        onClick={handleClose}
        sx={{ position: "absolute", right: 8, top: 8 }}
      >
        ✕
      </Button>

      <DialogContent style={{ marginTop: -25 }}>
        {/* Step 1: Choose login type */}
        {step === "choice" && (
          <Stack spacing={2} mt={2}>
            <p
              className="text-center"
              style={{ lineHeight: "20px", marginTop: "-20px" }}
            >
              Welcome back! <br />
              Please sign in to continue
            </p>
            <Button
              className="btn style1"
              variant="contained"
              fullWidth
              onClick={() => {
                setLoginType("mobile");
                setStep("mobile");
              }}
            >
              Login with Mobile
            </Button>

            {/* <Button
              className="btn style3"
              variant="outlined"
              fullWidth
              onClick={() => {
                //  setLoginType("email");
                // setStep("email");
              }}
            >
              Login with Email
            </Button> */}
            <div style={{ width: "100%", maxWidth: "100%", display:'flex', alignItems:'center', justifyContent:'center' }}>
              <GoogleLogin
                size="large" // only way to increase height
                width="100%"
                onSuccess={handleSuccess}
                onError={handleError}
              />
            </div>

            <p className="text-center" style={{ lineHeight: "20px" }}>
              By continuing, you agree to our <br />
              <a>Privacy Policy</a> and <a>Terms of Service</a>
            </p>
          </Stack>
        )}

        {/* Step 2A: Mobile */}
        {step === "mobile" && (
          <Stack spacing={2} mt={2}>
            <TextField
              value={Mobile}
              label="Mobile Number"
              type="tel"
              fullWidth
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // digits only
                if (value.length <= 10) {
                  setMobile(value);
                }
              }}
            />
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                // setStep("otp");
                checkMobile();
              }}
              className="btn style1"
              disabled={Mobile.length !== 10}
            >
              Send OTP
            </Button>
            <Button
              variant="text"
              onClick={() => setStep("choice")}
              className="btn style3"
            >
              Back
            </Button>
          </Stack>
        )}

        {/* Step 2B: Email */}
        {step === "email" && (
          <Stack spacing={2} mt={2}>
            <TextField label="Email Address" type="email" fullWidth />
            <Button
              variant="contained"
              fullWidth
              onClick={() => setStep("otp")}
              className="btn style1"
            >
              Send OTP
            </Button>
            <Button
              variant="text"
              onClick={() => setStep("choice")}
              className="btn style3"
            >
              Back
            </Button>
          </Stack>
        )}

        {step === "SignUp" && (
          <Stack spacing={2} mt={2}>
            <TextField
              value={Mobile}
              label="Mobile Number"
              type="tel"
              fullWidth
              onChange={(e) => setMobile(e.target.value)}
            />

            <TextField
              value={Name}
              label="Your Name"
              type="text"
              fullWidth
              onChange={(e) => setName(e.target.value)}
            />
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                signup();
                // setStep("otp");
                //checkMobile();
              }}
              className="btn style1"
              disabled={Mobile.length !== 10 && Name != ""}
            >
              Sign Up
            </Button>
            <Button
              variant="text"
              onClick={() => setStep("choice")}
              className="btn style3"
            >
              Back
            </Button>
          </Stack>
        )}

        {/* Step 3: OTP */}
        {step === "otp" && (
          <Stack spacing={2} mt={2}>
            <TextField
              value={otp}
              type="number"
              onChange={(e) => {
                const value = e.target.value.replace(/\D/g, ""); // digits only
                if (value.length <= 4) {
                  setOtp(value);
                }
              }}
              label="Enter OTP"
              fullWidth
            />
            <Button
              variant="contained"
              fullWidth
              className="btn style1"
              disabled={otp.length !== 4}
              onClick={handleVerify}
            >
              Verify & Login
            </Button>
            <Button
              variant="text"
              onClick={() =>
                setStep(loginType === "mobile" ? "mobile" : "email")
              }
              className="btn style3"
            >
              Back
            </Button>
          </Stack>
        )}
      </DialogContent>

      {Loading && (
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundColor: "rgba(255,255,255,0.7)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10,
          }}
        >
          <TailSpin color="#00BFFF" height={80} width={80} />
        </div>
      )}
    </Dialog>
  );
};

export default LoginDialog;
